import React from 'react'
import Box from '@mui/material/Box'
import styled from 'styled-components'

import { ActionCardProps } from 'types/TextAnalysis'
import { StyledTypography } from '../Helper'

const Wrapper = styled(Box)`
  padding-top: 0.75rem;
`

const CardContentDesc = ({ cardContent }: ActionCardProps) => {
  if (!cardContent) return null

  return (
    <Wrapper id="card-content">
      {typeof cardContent === 'string' ? (
        <StyledTypography
          variant="body"
          dangerouslySetInnerHTML={{
            __html: cardContent,
          }}
        />
      ) : (
        cardContent
      )}
    </Wrapper>
  )
}

export { CardContentDesc }
